import React from 'react';

export const ClientOffline = (): JSX.Element => {
  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'absolute',
        padding: '24px',
        boxSizing: 'border-box',
        textAlign: 'center',
        fontFamily: 'Poppins',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 17,
        lineHeight: '28px',
        letterSpacing: '0.005em',
        zIndex: 50,
        background: '#FFFFFF',
      }}
    >
      <img
        src={'assets/bigBangLab/use-larger-screen.png'}
        style={{ maxHeight: '80%', width: 'auto', maxWidth: 250 }}
        alt="fireSpot"
      />
      <span style={{ fontWeight: 700, fontSize: 24, fontFamily: 'Nunito' }}>
        Unable to connect to Big Bang Lab.
      </span>
      <span style={{ fontWeight: 700, fontSize: 24, fontFamily: 'Nunito' }}>
        Please check that you have a stable internet connection and try again.
      </span>
    </div>
  );
};
